
import { Component, Vue, Prop } from 'vue-property-decorator';

import { DepositModel } from '@/models/deposit'
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class DepositDetailFooter extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;
    
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }
}
